import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef } from '@angular/core';
import { LayoutContentbarsService } from './contentbars.service';
import { NgClass } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "./contentbars.service";
const _c0 = ["*"];
const _c1 = a0 => ({
  fixed: a0
});
function LayoutContentbarBottomComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@bottomBarAnimation", undefined)("@.disabled", !ctx_r0.animate)("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r0.fixed));
  }
}
export let LayoutContentbarBottomComponent = /*#__PURE__*/(() => {
  class LayoutContentbarBottomComponent {
    constructor(service, cd) {
      this.service = service;
      this.cd = cd;
      this.visible = true;
      this.animate = false;
      this.fixed = false;
      service.showBottomBar$.subscribe(val => {
        this.visible = val;
        this.cd.markForCheck();
      });
    }
    ngAfterViewInit() {
      // Skip initial animation as Safari is having trouble to render correctly
      setTimeout(() => {
        this.animate = true;
        this.cd.markForCheck();
      }, 50);
    }
    static {
      this.ɵfac = function LayoutContentbarBottomComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutContentbarBottomComponent)(i0.ɵɵdirectiveInject(i1.LayoutContentbarsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutContentbarBottomComponent,
        selectors: [["layout-contentbar-bottom"]],
        inputs: {
          fixed: "fixed"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        consts: [[1, "layout-footer", "clearfix", 3, "ngClass"]],
        template: function LayoutContentbarBottomComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵconditionalCreate(0, LayoutContentbarBottomComponent_Conditional_0_Template, 2, 5, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.visible ? 0 : -1);
          }
        },
        dependencies: [NgClass],
        styles: [".layout-footer[_ngcontent-%COMP%]{height:var(--bottombarHeight);background:#fff;position:absolute;bottom:0;left:0;right:0;z-index:101}.layout-footer.fixed[_ngcontent-%COMP%]{position:fixed}"],
        data: {
          animation: [trigger('bottomBarAnimation', [state('void', style({
            transform: "translateY(50px)"
          })), transition('void <=> *', animate(400))])]
        },
        changeDetection: 0
      });
    }
  }
  return LayoutContentbarBottomComponent;
})();